<template>
  <!-- 全局顶部导航 -->
  <div class="headerNav-wrap" v-if="!store.state.isMobile">
    <div class="inner">
      <div class="logo">
        <img src="../../assets/img/logo-hor.png" alt="" @click="router.push('/home')">
      </div>
      <div class="txt" v-if="store.state.user.userInfo.login">
        {{ $t("你好") }}，{{ store.state.user.userInfo.nickname }}！<br>
        <span>{{ $t("欢迎回来") }}！</span>
      </div>
	  <div class="countDownBox" v-if="store.state.user.userInfo.login && store.state.user.userInfo.creditRating == 0">
		  <img src="../../assets/img/icons/icon-em.png" class="em" alt="" @click="accountUnlockShow = true" style="cursor: pointer;"/>
		  <div class="txt">{{ $t("你的预约会议权限开放日为：") }}
        <span>{{ forDay(store.state.user.userInfo.limitTime) }}</span>
      </div>
	  </div>
      <div class="txt" v-if="!store.state.user.userInfo.login">
        {{ $t("欢迎使用与真空间，请先登录或注册账号") }}
      </div>
<!--      <div class="user-handle-wrap" v-if="store.state.user.userInfo.login">-->
<!--        <img src="../../assets/img/icons/icon-notice.png" alt="" class="notice" v-if="isHasNotice">-->
<!--        <img src="../../assets/img/icons/icon-notice-on.png" alt="" class="notice" v-else>-->
      <div class="user-handle-wrap" v-if="store.state.user.userInfo.login">
        <img src="../../assets/img/icons/icon-share.png" alt="" class="notice" :title="$t('点击复制黄页链接')" @click="copyYellowLink()">
        <img src="../../assets/img/icons/icon-notice.png" alt="" class="notice" v-if="isHasNotice" @click="router.push('/noticeList')">
        <img src="../../assets/img/icons/icon-notice-on.png" alt="" class="notice" v-else @click="router.push('/noticeList')">
        <div class="user-wrap" :class="{ hide: route.name != 'home' }" @mouseleave="isShowSlide = false" @mouseenter="isShowSlide = true">
          <div class="avatar">
<!--            <img :src="store.state.user.userInfo.avatar" >-->
            {{ store.state.user.userInfo.nickname ? store.state.user.userInfo.nickname.substring(0,1) : '' }}
          </div>
          <div class="name" v-show="route.name == 'home'">
            {{ store.state.user.userInfo.nickname }}
          </div>
          <img src="../../assets/img/icons/icon-arr-right-grey.png" alt="" class="arr" v-show="route.name == 'home'">
          <Transition name="slide-fade" v-show="isShowSlide">
            <div class="slide-wrap">
              <div class="info-wrap">
                <div class="info-avatar">
<!--                  <img :src="store.state.user.userInfo.avatar" >-->
                  {{ store.state.user.userInfo.nickname ? store.state.user.userInfo.nickname.substring(0,1) : '' }}
                </div>
                <div class="right">
                  <p class="right-name">
                    {{ store.state.user.userInfo.nickname }}
                  </p>
                  <p class="right-email">
                    {{ $t("用户ID") }}：{{ store.state.user.userInfo.yuzhenId}}
                  </p>
                </div>
              </div>
              <!-- 使用时长 -->
<!--              <div class="use-wrap">-->
<!--                <div class="use-title">-->
<!--                  {{ $t("使用时长") }}-->
<!--                </div>-->
<!--                <div class="use-scroll">-->
<!--                  <div id="line" class="line" :style="{width: store.state.user.userInfo.pexipDuration / store.state.user.userInfo.pexipTime * 100 + '%'}"></div>-->
<!--                </div>-->
<!--                <div class="use-time">-->
<!--                  {{ store.state.user.userInfo.pexipDuration }}min-->
<!--                  /-->
<!--                  {{ store.state.user.userInfo.pexipTime }}min-->
<!--                </div>-->
<!--                <div class="use-btn" @click="router.push('/exclusiveMeetingCode')">-->
<!--                  {{ $t("升级") }}-->
<!--                </div>-->
<!--              </div>-->
              <div class="use-wrap">
                <div class="use-title">
                  {{ $t("账户余额") }}
                </div>
                <div class="use-time">
                  {{ $t("余额") }}： ¥{{ store.state.user.userInfo.account / 100 }} {{ $t("元") }}
                  <br>
                  {{ $t("与真Coin") }}： ¥{{ store.state.user.userInfo.awardAccount / 100 }} {{ $t("元") }}
                </div>
                <div class="use-btn" @click="passShow = true">
                  {{ $t("充值") }}
                </div>
              </div>
              <div class="info-btn">
                <div class="info-item" @click="router.push('/userCenter')">
                  <img src="../../assets/img/icons/icon-userCenter.png" alt="">
                  <span>{{ $t("个人中心") }}</span>
                </div>
<!--                <div class="info-item" @click="sginout">-->
                <div class="info-item" @click="logout()">
                  <img src="../../assets/img/icons/icon-signOut.png" alt="">
                  <span>{{ $t("退出登录") }}</span>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
      <div class="handle-btn" v-else>
        <div class="btn btn-hover-animation" @click='router.push("/")'>
          {{ $t("登录") }}
        </div>
        <div class="btn btn-hover-animation" @click='router.push("/regin")'>
          {{ $t("注册") }}
        </div>
      </div>
    </div>
  </div>
  <div class="mob-wrap" v-else>
    <div class="logo">
      <img src="../../assets/img/logo-mob.png" alt="" @click="router.push('/home')">
    </div>
<!--    <div class="handle-wrap" v-if="store.state.user.userInfo.login">-->
<!--      <img src="../../assets/img/icons/icon-notice.png" alt="" class="notice" v-if="isHasNotice">-->
<!--        <img src="../../assets/img/icons/icon-notice-on.png" alt="" class="notice" v-else>-->
    <div class="handle-wrap" v-if="store.state.user.userInfo.login">
      <img src="../../assets/img/icons/icon-share.png" alt="" class="notice" :title="$t('点击复制黄页链接')" @click="copyYellowLink()">
      <img src="../../assets/img/icons/icon-notice.png" alt="" class="notice" v-if="isHasNotice" @click="router.push('/noticeList')">
        <img src="../../assets/img/icons/icon-notice-on.png" alt="" class="notice" v-else @click="router.push('/noticeList')">
      <div class="avatar" @click="router.push('/userInfo')">
<!--        <img :src="store.state.user.userInfo.avatar" >-->
        {{ store.state.user.userInfo.nickname ? store.state.user.userInfo.nickname.substring(0,1) : '' }}
      </div>
    </div>
    <div class="handle-btn" v-else>
        <div class="btn btn-hover-animation" @click='router.push("/")'>
          {{ $t("登录") }}
        </div>
        <div class="btn btn-hover-animation" @click='router.push("/regin")'>
          {{ $t("注册") }}
        </div>
      </div>
  </div>

  <!-- 充值弹窗 -->
  <Transition>
    <div class="pop-bg pass" v-show="passShow">
      <div class="pop-box">
        <p>{{ $t("在线充值") }}</p>
        <img src="../../assets/img/icons/icon-close.png" alt="" class="close" @click="passShow = false">
        <div class="amend binding-tel">
          <div class="code">
<!--            <div class="input-wrap">-->
<!--              <img src="../../assets/img//icons/icon-code.png" alt="">-->
<!--              <input type="text" v-model="money" :placeholder="$t('请输入金额')">-->
<!--            </div>-->

            <div class="item" :class="{ active: choice == index }" @click="choiceMoney(item.id,index)" v-for="(item, index) in state.moneyList"
                 :key="item.id">
              <!-- <p class="title"> -->
                <span>{{ item.name }}</span>
              <!-- </p> -->
            </div>
            <!-- <div class="item" :class="{ active: choice == 10 }" @click="choiceMoney(10,10)">
              <input type="text" style="border: none;width: 5.75vw;" v-model="money" :placeholder="$t('请输入金额')">
            </div> -->


          </div>
		  <div class="other" @click="choiceMoney(10,10)">
		  	<span>{{ $t('其他金额') }}</span>
			<input type="text"  v-model="money" :placeholder="$t('请输入其他金额')">
		  </div>
          <div class="next" @click="topUp('alipay_pc')">{{ $t("支付宝充值") }}</div>
        </div>
      </div>
    </div>
  </Transition>

  <AccountUnlock  :isToastShow="accountUnlockShow" @closeToast="closeToast" ></AccountUnlock>
</template>

<script setup>
import {getCurrentInstance, onMounted, onUnmounted, reactive, ref} from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import {ElMessage} from "element-plus";
import {createTopUpOrder, getPayOrder, submitOrder} from "@/api/yuzhen/order";
import {PayChannelEnum, PayDisplayModeEnum, topMoneyEnum} from "@/utils/constants";
import {getUserYellowPages} from "@/api/yuzhen/yellowPages";
import useClipboard from "vue-clipboard3";
import {alertCopyResult} from "@/composables/utils";
import AccountUnlock from "../../components/accountUnlock/accountUnlock.vue";
import {yellowPagesUrl} from "@/config/config";

// 多语言调用
const { appContext : { config: { globalProperties } } } = getCurrentInstance();
const store = useStore();
const router = useRouter();
const route = useRoute();

const isShowSlide = ref(false);
const isHasNotice = ref(false);
const passShow = ref(false)
const accountUnlockShow = ref(false) // 账户解锁弹窗
const money = ref("")
const choice = ref(-1); // 选中
const choiceId = ref(0); // 选中的id
const orderId = ref(0); // 账单id
const state = reactive({
  moneyList: topMoneyEnum
})

// 关闭账户解锁弹窗
function closeToast(){
  accountUnlockShow.value = false
}

function choiceMoney(id,index){
  choice.value = index
  choiceId.value = id
}

function copyYellowLink(){
  // 获取黄页信息
  getUserYellowPages().then(res => {
    if(res.data != null){
      // 复制链接
      copy(yellowPagesUrl + res.data.web)
    }else {
      ElMessage({
        type: 'error',
        message: globalProperties.$t("请先配置与真黄页"),
      })
    }
  }).catch(err => {
    console.log(err)
  })
}

// 点击粘贴
const { toClipboard } = useClipboard();
async function copy(text) {
  try {
    await toClipboard(text);
    // alertCopyResult(globalProperties.$t("已复制"));
    ElMessage({
      type: 'success',
      message: globalProperties.$t("已复制黄页链接"),
    })
  } catch (e) {
    // alertCopyResult(globalProperties.$t("复制失败"));
    ElMessage({
      type: 'error',
      message: globalProperties.$t("复制黄页链接失败"),
    })
    console.error(e);
  }
}

let interval = undefined;
function topUp(channelCode) {
  // let reg = /^\d+$/;
  // if(!money.value){
  //   ElMessage({
  //     type: 'error',
  //     message: globalProperties.$t("请输入金额"),
  //   })
  //   return
  // }
  // if(!reg.test(money.value) || money.value === '0'){
  //   ElMessage({
  //     type: 'error',
  //     message: globalProperties.$t("请输入真实金额"),
  //   })
  //   return
  // }
  if (choiceId.value == 0) {
    ElMessage({
      type: 'error',
      message: globalProperties.$t("请选择金额"),
    })
    return
  }
  var data = {
    currency: 'CNY'
  }
  if(choiceId.value == 10){
    // 使用正则表达式检查输入是否为整数
    var integerPattern = /^\d+$/;
    if (integerPattern.test(money.value)) {
      data.price = money.value
    }else {
      ElMessage({
        type: 'error',
        message: globalProperties.$t("金额需为整数"),
      })
      return
    }
  }else {
    state.moneyList.forEach(item => {
      if (item.id == choiceId.value){
        data.price = item.price
      }
    })
  }
  let newWin = window.open();

  createTopUpOrder(data).then(res => {
    orderId.value = res.data.id
    pay(channelCode,res.data.payOrderId,newWin)
  }).catch(err => {
    newWin.close();
    console.log(err)
  })
}

function pay(channelCode,orderId,newWin){

  //return;
  //isPaymentShow.value = false;
  //isPaymentResultShow.value = true;
  submitOrder({
    id: orderId,
    channelCode: channelCode,
    ...buildSubmitParam(channelCode)
  }).then(response => {
    const data = response.data
    if (data.displayMode === PayDisplayModeEnum.IFRAME.mode) {
      //this.displayIFrame(channelCode, data)
    } else if (data.displayMode === PayDisplayModeEnum.URL.mode) {
      displayUrl(channelCode, data,newWin)
    } else if (data.displayMode === PayDisplayModeEnum.FORM.mode) {
      document.write(data.displayContent);//自动提交表单数据
    } else if (data.displayMode === PayDisplayModeEnum.QR_CODE.mode) {
      //this.displayQrCode(channelCode, data)
    }

    // 打开轮询任务
    createQueryInterval()
  }).catch(() => {
    // this.submitLoading = false
  });
}

function buildSubmitParam(channelCode) {
  // ① 支付宝 PC 支付时，有多种展示形态
  if (channelCode === PayChannelEnum.ALIPAY_PC.code) {
    // 情况【前置模式】：将二维码前置到商户的订单确认页的模式。需要商户在自己的页面中以 iframe 方式请求支付宝页面。具体支持的枚举值有以下几种：
    // 0：订单码-简约前置模式，对应 iframe 宽度不能小于 600px，高度不能小于 300px
    // return {
    //   "channelExtras": {
    //     "qr_pay_mode": "0"
    //   }
    // }
    // 1：订单码-前置模式，对应iframe 宽度不能小于 300px，高度不能小于 600px
    // return {
    //   "channelExtras": {
    //     "qr_pay_mode": "1"
    //   }
    // }
    // 3：订单码-迷你前置模式，对应 iframe 宽度不能小于 75px，高度不能小于 75px
    // return {
    //   "channelExtras": {
    //     "qr_pay_mode": "3"
    //   }
    // }
    // 4：订单码-可定义宽度的嵌入式二维码，商户可根据需要设定二维码的大小
    // return {
    //   "channelExtras": {
    //     "qr_pay_mode": "4"
    //   }
    // }
    // 情况【跳转模式】：跳转模式下，用户的扫码界面是由支付宝生成的，不在商户的域名下。支持传入的枚举值有
    // return {
    //   "channelExtras": {
    //     "qr_pay_mode": "2"
    //   }
    // }
    // 情况【表单模式】：直接提交当前页面到支付宝
    return {
      displayMode: PayDisplayModeEnum.URL.mode
      //displayMode: PayDisplayModeEnum.FORM.mode
    }
  }

  // ② 支付宝 Wap 支付时，引导手机扫码支付
  if (channelCode === PayChannelEnum.ALIPAY_WAP.code) {
    return {
      displayMode: PayDisplayModeEnum.QR_CODE.mode
    }
  }

  // ③ 支付宝 BarCode 支付时，需要传递 authCode 条形码
  if (channelCode === PayChannelEnum.ALIPAY_BAR.code) {
    return {
      "channelExtras": {
        "auth_code": this.barCode.value
      }
    }
  }
  return {}
}

/** 提交支付后，URL 的展示形式 */
function displayUrl(channelCode, data,newWin) {
  newWin.location.href = data.displayContent;
  //window.open(data.displayContent)
  //let newWin = window.open();
  //newWin.document.body.innerHTML = data.displayContent;
  //newWin.document.querySelector('form[name="punchout_form"]').submit()
}

/** 轮询查询任务 */
function createQueryInterval() {
  if (interval) {
    return
  }
  interval = setInterval(() => {
    getPayOrder(orderId.value).then(response => {
      if (!response.data)
        return;
      // 已支付
      if (response.data.status == 2) {
        clearQueryInterval();
        ElMessage({
          type: 'success',
          message: globalProperties.$t("充值成功"),
        })
        passShow.value = false
        // 更新用户余额
        store.dispatch("user/UpdateInfo").then(res=>{}).catch(err=>{})
      }
      // 已取消
      if (response.data.status == 3) {
        clearQueryInterval();
        ElMessage({
          type: 'error',
          message: globalProperties.$t("充值取消"),
        })
        // 更新用户余额
        store.dispatch("user/UpdateInfo").then(res=>{}).catch(err=>{})
      }
    }).catch(err => {
      console.log(err)
    })
  }, 1000 * 2)
}
/** 清空查询任务 */
function clearQueryInterval() {
  clearInterval(interval)
  interval = undefined
}

/**
 * 退出登录
 */
function logout(){
  store.state.user.userInfo.login = false;
  store.dispatch("user/LogOut")
  router.push("/")
}

/**
 * 退出登录
 */
function sginout() {
  store.dispatch("user/asyncUpdateInfo", null)
  router.push("/")
}

/**
 * 计算天数
 */
function intervalDay(time){
  if(time == null){
    return 0;
  }
  return Math.ceil( (time - new Date().getTime()) / 86400000 )
}

function forDay(time){
  let year = new Date(time).getFullYear()
  let month = new Date(time).getMonth() + 1
  let date = new Date(time).getDate() + 1
  return year + "/" + month + "/" + date

}



onMounted(() => {
  const userinfo = JSON.parse(localStorage.getItem('userInfo'))
  if(userinfo !== null && userinfo.login){
    store.dispatch("user/asyncUpdateInfo",userinfo)
  }
  // if(!store.state.user.userInfo.login){
  //   router.push("/")
  // }
})

// 组件销毁时函数
// onUnmounted(() => {
//   localStorage.setItem(
//       'userInfo',
//       JSON.stringify(store.state.user.userInfo)
//   )
// })
</script>

<style src="./headerNav.css" scoped></style>
